import _ from 'lodash';

const fetchTranscoderEnvironment = (props) => {
  if (props.studentId) {
    if (props.bulbAttemptId) {
      return 'student-bulb-attempt';
    } else if (props.questionId) {
      return 'student-question-attempt';
    } else if (props.discussionId) {
      return 'student-discussion';
    }
    return false;
  } else if (props.teacherId) {
    if (props.bulbId) {
      return 'teacher-bulb';
    } else if (props.lessonId) {
      return 'teacher-lesson';
    } else if (props.discussionId) {
      return 'teacher-discussion';
    } else if (props.discussionAttemptInteractionId) {
      return 'teacher-discussion-attempt';
    }
    return false;
  }
  return false;
};

const fetchQueryString = (props, transcoderEnvironment) => {
  let queryObj = {};
  if (transcoderEnvironment === 'teacher-bulb') queryObj = _.pick(props, ['teacherId', 'bulbId']);
  else if (transcoderEnvironment === 'teacher-lesson') queryObj = _.pick(props, ['teacherId', 'lessonId']);
  else if (transcoderEnvironment === 'teacher-discussion') queryObj = _.pick(props, ['teacherId', 'discussionId']);
  else if (transcoderEnvironment === 'teacher-discussion-attempt') queryObj = _.pick(props, ['teacherId', 'discussionAttemptInteractionId']);
  else if (transcoderEnvironment === 'student-bulb-attempt') queryObj = _.pick(props, ['studentId', 'bulbAttemptId']);
  else if (transcoderEnvironment === 'student-question-attempt') queryObj = _.pick(props, ['studentId', 'questionId']);
  else if (transcoderEnvironment === 'student-discussion') queryObj = _.pick(props, ['studentId', 'discussionId']);
  return `?${Object.keys(queryObj).map((key) => `${key}=${queryObj[key]}`).join('&')}`;
};

export default {
  constructTranscoderEnvironment({ commit }, props) {
    const environment = fetchTranscoderEnvironment(props);
    if (!environment) return Promise.reject('Unable to determine the video transcoder environment from the given props.');
    const queryString = fetchQueryString(props, environment);
    commit('updateTranscoderEnvironment', environment);
    commit('updateQueryString', queryString);
    return true;
  },
};